import API from "../config";

export const BRANDING_STORAGE_KEY = "company_branding";
export const BRANDING_CHANGED_EVENT = "company-branding-changed";

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

export const getStoredBranding = () => {
  try {
    return JSON.parse(localStorage.getItem(BRANDING_STORAGE_KEY) || "null");
  } catch {
    return null;
  }
};

export const storeBranding = (branding) => {
  localStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(branding || null));
  window.dispatchEvent(new Event(BRANDING_CHANGED_EVENT));
};

export const loadCompanyBranding = async () => {
  const token = localStorage.getItem("token");
  const user = readUser();
  if (!token || !user.company_id) return null;

  const response = await fetch(`${API}/companies`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Unable to load company branding");

  const payload = await response.json();
  const companies = Array.isArray(payload) ? payload : payload?.data || [];
  const company = companies.find((item) => Number(item.id) === Number(user.company_id)) || null;
  if (company) storeBranding(company);
  return company;
};
